module.exports = __webpack_public_path__ + "static/img/Brandon_Ellis_desktop.bde7e48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Brandon_Ellis_desktop.jpg
// module id = qNAH
// module chunks = 0